import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Alert from '@mui/material/Alert';
import EcdResuscitateNoIcon from 'assets/icons/ecd-resuscitate-no.svg?react';
import EcdResuscitateYesIcon from 'assets/icons/ecd-resuscitate-yes.svg?react';

import ElectronicClientRecordResuscitationDecisionType from 'features/residents/models/electronic-client-record-resuscitation-decision-type';
import styles from './resuscitation-alert.module.scss';

type Props = {
  resuscitationDecisionType?: ElectronicClientRecordResuscitationDecisionType;
};

const ResuscitationAlert = ({ resuscitationDecisionType }: Props): React.JSX.Element => {
  const { t } = useTranslation('residentsSettings', { keyPrefix: 'resuscitationAlert' });

  const renderContent = (): ReactNode => {
    switch (resuscitationDecisionType) {
      case ElectronicClientRecordResuscitationDecisionType.No:
        return (
          <Alert
            icon={<EcdResuscitateNoIcon className={styles.resuscitationIcon} />}
            className={`${styles.resuscitationAlert} ${styles.resuscitationNo}`}
          >
            {t('resuscitationNo')}
          </Alert>
        );
      case ElectronicClientRecordResuscitationDecisionType.Yes:
        return (
          <Alert
            icon={<EcdResuscitateYesIcon className={styles.resuscitationIcon} />}
            className={`${styles.resuscitationAlert} ${styles.resuscitationYes}`}
          >
            {t('resuscitationYes')}
          </Alert>
        );
      default:
        return null;
    }
  };

  return <>{renderContent()}</>;
};

export default ResuscitationAlert;
